const env = (globalThis as GlobalThis)._NGX_ENV_ ?? import.meta.env ?? ({} as Env);

export const environment = {
  production: false,
  name: env.NG_APP_ENV,
  apiUrl: env.NG_APP_API_URL,
  sockApiUrl: env.NG_APP_SOCK_API_URL || env.NG_APP_API_URL,
  apiPrefix: '/api',
  internalOkta: {
    clientId: env.NG_APP_OKTA_INTERNAL_CLIENT_ID,
    issuer: env.NG_APP_OKTA_INTERNAL_ISSUER,
    redirectUri: env.NG_APP_OKTA_INTERNAL_REDIRECT_URI,
    scopes: env.NG_APP_OKTA_INTERNAL_SCOPES,
    pkce: env.NG_APP_OKTA_INTERNAL_PKCE,
  },
  externalOkta: {
    clientId: env.NG_APP_OKTA_EXTERNAL_CLIENT_ID,
    issuer: env.NG_APP_OKTA_EXTERNAL_ISSUER,
    redirectUri: env.NG_APP_OKTA_EXTERNAL_REDIRECT_URI,
    scopes: env.NG_APP_OKTA_EXTERNAL_SCOPES,
    pkce: env.NG_APP_OKTA_EXTERNAL_PKCE,
  },
  showSsoLogin: env.NG_APP_SHOW_SSO_LOGIN === 'true',
  showClientFeedback: env.NG_APP_SHOW_CLIENT_FEEDBACK === 'true',
  helpUrlInternal: env.NG_APP_HELP_URL_INTERNAL,
  helpUrlExternal: env.NG_APP_HELP_URL_EXTERNAL,
  newRelic: {
    enabled: env.NG_APP_NEW_RELIC_ENABLED === 'true',
    accountID: env.NG_APP_NEW_RELIC_ACCOUNT_ID,
    applicationID: env.NG_APP_NEW_RELIC_APPLICATION_ID,
    licenseKey: env.NG_APP_NEW_RELIC_LICENSE_KEY,
  },
  logRocket: {
    enabled: env.NG_APP_LOGROCKET_ENABLED === 'true',
    appId: env.NG_APP_LOGROCKET_APP_ID,
  },
};
